import { Filter } from '../../models';

export const peopleFilter: Filter[] = [
  {
    title: 'Faculty',
    field: 'faculty',
    metadataField: 'faculty',
    options: [
      { title: 'Business and Law', value: 'Faculty of Business and Law', metadataValue: 'business-and-law' },
      { title: 'Health Sciences', value: 'Faculty of Health Sciences', metadataValue: 'health-sciences' },
      { title: 'Humanities', value: 'Faculty of Humanities', metadataValue: 'humanities' },
      {
        title: 'Science and Engineering',
        value: 'Faculty of Science and Engineering',
        metadataValue: 'science-and-engineering',
      },
    ],
  },
  {
    title: 'Staff type',
    field: 'staff_type',
    metadataField: 'staff_type',
    options: [
      { title: 'Academic', value: 'Academic', metadataValue: 'academic' },
      { title: 'Professional', value: 'Professional', metadataValue: 'professional' },
      { title: 'Research', value: 'Researcher', metadataValue: 'research' },
    ],
  },
  {
    title: 'Location',
    field: 'staff.location.campus.code.keyword',
    metadataField: 'staff_location',
    options: [
      { title: 'Perth', value: ['PERT', 'BENT'], metadataValue: 'perth' },
      { title: 'Bentley', value: ['BENT', 'CIC'], metadataValue: 'bentley' },
    ],
  },
];
